import api from "./api";

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  addQueue({ commit }, data) {
    return api
      .addQueue(data)
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
  getQueueList({ commit }, { limit, cursor }) {
    return api
      .getQueueList(limit, cursor)
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
  getHistoryList({ commit }, { limit, cursor }) {
    return api
      .getHistoryList(limit, cursor)
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
  clearHistory({ commit }) {
    return api
      .clearHistory()
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
  resendEmail({ commit }, { id }) {
    return api
      .resendEmail(id)
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
  deleteEmail({ commit }, { id }) {
    return api
      .deleteQueueEmail(id)
      .then((data) => data.data)
      .catch((err) => {
        throw err.data;
      });
  },
};

const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
